import { useState } from "react";

import { type DateRate } from "./DateRateTable.types";

const DATE_RATES_PER_PAGE = 5;

const FIRST_PAGE = 1;

/**
 * Client-side paging for the date rates table: the API returns every upcoming
 * date, so this slices `dateRates` into pages of DATE_RATES_PER_PAGE. The page
 * is clamped to the last one, so a shrinking list (after a delete or refetch)
 * never leaves the table on an empty page.
 */
const useDateRatePagination = (dateRates: DateRate[]) => {
  const [requestedPage, setPage] = useState(FIRST_PAGE);

  const pageCount = Math.max(
    FIRST_PAGE,
    Math.ceil(dateRates.length / DATE_RATES_PER_PAGE),
  );
  const page = Math.min(requestedPage, pageCount);
  const pageStart = (page - FIRST_PAGE) * DATE_RATES_PER_PAGE;
  const pageDateRates = dateRates.slice(
    pageStart,
    pageStart + DATE_RATES_PER_PAGE,
  );

  return { page, pageCount, pageDateRates, setPage };
};

export { useDateRatePagination };
